<template>
  <div class="employee-bar-chart">
    <canvas ref="barChart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'

export default {
  name: 'HomeEmployeeBarChart',
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.renderChart()
  },
  watch: {
    data() {
      this.renderChart()
    }
  },
  methods: {
    renderChart() {
      if (this._chart) {
        this._chart.destroy()
      }
      const ctx = this.$refs.barChart.getContext('2d')
      const labels = this.data.map(item => item.name)
      const totalData = this.data.map(item => item.total)
      const finishedData = this.data.map(item => item.finished)
      this._chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: '工单总数',
              data: totalData,
              backgroundColor: '#42b983'
            },
            {
              label: '已完成工单数',
              data: finishedData,
              backgroundColor: '#67c23a'
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            legend: { position: 'top' },
            title: { display: true, text: '员工工单统计' }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.employee-bar-chart {
  background: var(--color-bg-3);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  padding: 24px;
  color: var(--color-text-1);
}
canvas {
  width: 100% !important;
  height: 320px !important;
}
</style>